import { Reducer } from "../../lib/redux";
import { RouteActionTypes } from "./types";
import { RouteActions } from "./actions";
import { IRoute } from "../../model/Message";
import { extend } from "../../utils/vanilla";

export let defaultRoutes: IIdDictionary<IIdDictionary<IRoute>> = {};

export let routes: Reducer<IIdDictionary<IIdDictionary<IRoute>>, RouteActions> = (state = defaultRoutes, action) => {
    switch (action.type) {
        case RouteActionTypes.SET_ROUTES: {
            const userId = action.payload.userId;
            const route: IIdDictionary<IRoute> = action.payload.routes ? extend(true, {}, action.payload.routes) : {};
            if (userId) {
                return {
                    ...state,
                    [userId]: route
                };
            }
            return state;
        }
        case RouteActionTypes.CLEAR_ROUTES: {
            const userId = action.payload.userId;
            if (userId) {
                let newState = { ...state };
                delete newState[userId];
                return newState;
            }
            return defaultRoutes;
        }
        default: {
            return state;
        }
    }
};